var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-floating-btn"},[_c('button',{staticClass:"base-floating-btn__btn",on:{"click":_vm.emitClickEvent}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }